// Generated by ReScript, PLEASE EDIT WITH CARE


function toString(workUnit) {
  switch (workUnit.TAG | 0) {
    case /* Order */0 :
        return "ORDER";
    case /* Login */1 :
        return "LOGIN";
    case /* Mbg */2 :
        return "MBG";
    
  }
}

export {
  toString ,
  
}
/* No side effect */
